import { render, staticRenderFns } from "./assemble_list.vue?vue&type=template&id=c6e240a6&scoped=true"
import script from "./assemble_list.vue?vue&type=script&lang=js"
export * from "./assemble_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e240a6",
  null
  
)

export default component.exports